/* eslint-disable */

import { defineStore } from "pinia";
import { useCustomerStore } from "./customer";

export const useReferralStore = defineStore("referral", {
	state: () => ({
		friend_referral_code: null,
		referral_friend_loading: false,
		referral_code: null,
		referral_code_loading: false,
		referral_link: null,
		disabled: false,
		how_it_works: null,
		dashoboard_loading: false,
		dashboard_registered_users: 0,
		dashboard_active_users: 0,
		dashboard_total_earnings: 0,
		activity_date_range: {
			from: null,
			to: null,
		},
		players_date_range: {
			from: null,
			to: null,
		},
		referral_activity: {
			data: [],
			pagination: {
				current_page: 1,
				last_page: 1,
				per_page: 5,
				total: 0,
			},
		},
		referral_activity_summary: {
			summary: null,
			products: [],
		},
		referral_activity_loading: false,
		referral_players: {
			data: [],
			pagination: {
				current_page: 1,
				last_page: 1,
				per_page: 5,
				total: 0,
			}
		},
		referral_players_summary: {
			summary: null,
		},
		referral_players_loading: false,
		price_up: false,
		price_down: false,
		initialization_loading: false,
	}),
	getters: {
		getReferralActivity(state) {
			const referral_aou = _.cloneDeep(state.referral_activity);
			referral_aou.data = _.chain(referral_aou.data).orderBy('created_at', 'desc').take(referral_aou.pagination.per_page).value()
			return referral_aou;
		},
		getReferralActivitySummary(state) {
			return state.referral_activity_summary;
		},
		getReferralPlayers(state) {
			return state.referral_players;
		},
		getReferralPlayersSummary(state) {
			return state.referral_players_summary;
		},
	},
	actions: {
		setReferralActivityUpdate(dato) {
			// Todoinx maybe i receive again the same instance as update :/
			const old_amou = this.referral_activity_summary.summary.pending_amount;

			this.referral_activity_summary.summary.pending_amount = Number(this.referral_activity_summary.summary.pending_amount) + Number(dato.calculated_commission);
			if (old_amou < this.referral_activity_summary.summary.pending_amount) {
				this.price_up = true;
			}

			if (old_amou > this.referral_activity_summary.summary.pending_amount) {
				this.price_down = true;
			}

			setTimeout(() => {
				this.price_up = false;
				this.price_down = false;
			}, 5000);

				if (this.referral_activity.pagination.current_page != 1) return;
			this.referral_activity.data.unshift(dato)
			this.referral_activity.pagination.total++;
		},
		updateReferralCode() {
			if (!this.referral_code) return Promise.reject('Referral code is required');

			this.referral_code_loading = true;

			return global.axios.post(process.env.VUE_APP_API_URL + '/account/referrals/update-code', {code: this.referral_code}).then((response) => {
				const customerStore = useCustomerStore();
				customerStore.customer = { ...customerStore.customer, ...response.data.customer };

				this.referral_code = response.data.referral_code;
				this.referral_link = response.data.referral_link;
				this.disabled = true;

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			}).finally(() => {
				this.referral_code_loading = false;
			});
		},
		fetchCommissionHistory(payload = {}) {
			const customerStore = useCustomerStore();
			// Do not attempt to fetch if not logged in
			if (!customerStore.isLoggedIn) return;

			const params = {
				page: payload.page || 1,
				per_page: payload.per_page || 20,
				execution_type: payload.execution_type || 'daily',
				period_start: payload.period_start,
				period_end: payload.period_end,
			};

			return global.axios.get(process.env.VUE_APP_API_URL + '/account/referrals/commission-history', { params }).then((response) => {
				return Promise.resolve(response);
			}).catch((error) => {
				return Promise.reject(error.response);
			});
		},
		fetchReferralActivity(payload = {}) {
			const customerStore = useCustomerStore();
			// Do not attempt to fetch if not logged in
			if (!customerStore.isLoggedIn) return;

			this.referral_activity_loading = true;

			const params = {
				from: payload.from,
				to: payload.to,
				product_id: payload.product_id,
				page: payload.page || 1,
				per_page: payload.per_page ?? 5, // Use nullish coalescing to ensure 5 is used if undefined/null
			};

			return global.axios.get(process.env.VUE_APP_API_URL + '/account/referrals/activity', { params }).then((response) => {
				const body = response.data || response;
				const activityData = Array.isArray(body.data) ? body.data : [];

				// Extract pagination: prefer meta (Laravel), then pagination (old format), then defaults
				const meta = body.meta || body.pagination || {};
				const pagination = {
					current_page: meta.current_page ?? payload.page ?? 1,
					last_page: meta.last_page ?? 1,
					per_page: meta.per_page ?? payload.per_page ?? 5,
					total: meta.total ?? 0,
				};

				this.referral_activity = {
					data: activityData,
					pagination: pagination,
				};

				this.referral_activity_loading = false;
				return Promise.resolve(response);
			}).catch((error) => {
				this.referral_activity_loading = false;
				return Promise.reject(error.response);
			});
		},
		fetchReferralActivitySummary(payload = {}) {
			const customerStore = useCustomerStore();
			// Do not attempt to fetch if not logged in
			if (!customerStore.isLoggedIn) return;

			const params = {
				from: payload.from,
				to: payload.to,
			};

			return global.axios.get(process.env.VUE_APP_API_URL + '/account/referrals/activity/summary', { params }).then((response) => {
				const body = response.data || response;
				const summary = body.summary || null;
				const products = Array.isArray(body.products) ? body.products : [];

				this.referral_activity_summary = {
					summary: summary,
					products: products,
				};

				return Promise.resolve(response);
			}).catch((error) => {
				return Promise.reject(error.response);
			});
		},
		fetchReferralPlayers(payload = {}) {
			const customerStore = useCustomerStore();
			// Do not attempt to fetch if not logged in
			if (!customerStore.isLoggedIn) return;

			this.referral_players_loading = true;

			const params = {
				from: payload.from,
				to: payload.to,
				page: payload.page || 1,
				per_page: payload.per_page ?? 5,
			};

			return global.axios.get(process.env.VUE_APP_API_URL + '/account/referrals/players', { params }).then((response) => {
				const body = response.data || response;
				const playersData = Array.isArray(body.data) ? body.data : [];

				// Extract pagination: prefer meta (Laravel), then pagination (old format), then defaults
				const meta = body.meta || body.pagination || {};
				const pagination = {
					current_page: meta.current_page ?? payload.page ?? 1,
					last_page: meta.last_page ?? 1,
					per_page: meta.per_page ?? payload.per_page ?? 5,
					total: meta.total ?? 0,
				};

				this.referral_players = {
					data: playersData,
					pagination,
				};

				this.referral_players_loading = false;
				return Promise.resolve(response);
			}).catch((error) => {
				this.referral_players_loading = false;
				return Promise.reject(error.response);
			});
		},
		fetchReferralPlayersSummary(payload = {}) {
			const customerStore = useCustomerStore();
			// Do not attempt to fetch if not logged in
			if (!customerStore.isLoggedIn) return;

			const params = {
				from: payload.from,
				to: payload.to,
			};

			return global.axios.get(process.env.VUE_APP_API_URL + '/account/referrals/players/summary', { params }).then((response) => {
				const body = response.data || response;
				this.referral_players_summary = {
					summary: body.summary || null,
				};
				return Promise.resolve(response);
			}).catch((error) => {
				return Promise.reject(error.response);
			});
		},
		generateReferralCode() {
			this.referral_code_loading = true;

			return global.axios.post(process.env.VUE_APP_API_URL + '/account/referrals/generate-code').then((response) => {
				this.referral_code = response.data.referral_code;
				this.referral_link = response.data.referral_link;

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			}).finally(() => {
				this.referral_code_loading = false;
			});
		},
		setCookie(name, value, minutes) {
			const expires = new Date();
			expires.setTime(expires.getTime() + (minutes * 60 * 1000));
			document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + expires.toUTCString() + ';path=/';
		},
		clearCookie(name) {
			// Set cookie with expired date to clear it
			document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;';
		},
		clearReferralCookie() {
			// Convenience method to clear the referral_code cookie
			this.clearCookie('referral_code');
		},
		clearDateRanges() {
			// Clear persisted date ranges when user logs out
			this.activity_date_range = {
				from: null,
				to: null,
			};
			this.players_date_range = {
				from: null,
				to: null,
			};
			// Also clear activity data on logout
			this.clearReferralActivity();
			this.clearReferralPlayers();
		},
		clearReferralActivity() {
			// Clear activity data when component unmounts or user logs out
			this.referral_activity = {
				data: [],
				pagination: {
					current_page: 1,
					last_page: 1,
					per_page: 5,
					total: 0,
				},
			};
			this.referral_activity_summary = {
				summary: null,
				products: [],
			};
		},
		clearReferralPlayers() {
			this.referral_players = {
				data: [],
				pagination: {
					current_page: 1,
					last_page: 1,
					per_page: 5,
					total: 0,
				},
			};
			this.referral_players_summary = {
				summary: null,
			};
		},
		transferBalance(amount = null) {
			const payload = amount ? { amount } : {};
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/referrals/transfer', payload).then((response) => {
				return Promise.resolve(response.data);
			}).catch((error) => Promise.reject(error.response));
		},
		submitReferralCode() {
			if (!this.friend_referral_code) return Promise.reject('Referral code is required');

			this.referral_friend_loading = true;

			return global.axios.post(process.env.VUE_APP_API_URL + '/account/referrals/link-referrer', { referral_code: this.friend_referral_code }).then((response) => {

				const customerStore = useCustomerStore();
				customerStore.setCustomer(response.data?.customer);
				customerStore.customer = { ...customerStore.customer, ...response.data.referral_resource };

				return Promise.resolve(response.data);
			}).catch((error) => {

				return Promise.reject(error.response);
			}).finally(() => {
				this.referral_friend_loading = false;
			})
		},
		fetchDashboardInfo() {
			this.dashoboard_loading = true;

			return global.axios.get(process.env.VUE_APP_API_URL + '/account/referrals/dashboard/info').then((response) => {

				this.dashboard_registered_users = response.data.users_registered;
				this.dashboard_active_users = response.data.active_users_count;
				this.dashboard_total_earnings = response.data.total_commission;

				return Promise.resolve(response.data);
			}).catch((error) => {
				console.log(error);
				return Promise.reject(error.response);
			}).finally(() => {
				this.dashoboard_loading = false;
			})
		},
		fetchReferralCustomerInfo() {
			this.initialization_loading = true;

			return global.axios.get(process.env.VUE_APP_API_URL + '/account/referrals/customer/info').then((response) => {
				const customerStore = useCustomerStore();
				customerStore.customer = { ...customerStore.customer, ...response.data.data };

				return Promise.resolve(response.data);
			}).catch((error) => {
				console.log(error);
				return Promise.reject(error.response);
			}).finally(() => {
				this.initialization_loading = false;
			})
		}
	},
	persist: {
		storage: localStorage,
		paths: [
			'activity_date_range',
			'players_date_range',
			'referral_activity.data',
			'referral_activity.pagination.current_page',
			'referral_activity.pagination.total',
			'referral_activity.pagination.last_page',
			'referral_activity_summary',
			'referral_players.data',
			'referral_players.pagination.current_page',
			'referral_players.pagination.total',
			'referral_players.pagination.last_page',
			'referral_players_summary',
		],
	},
});
